<template>
  <div class="c-select_wrap">
    <select
      v-model="selectedProductId"
      class="form-control c-select"
      style="width: 300px">
      <option
        v-for="(product, index) in availableProducts"
        :key="index"
        :value="product.id">
        {{ product.title }}
      </option>
    </select>
  </div>
</template>

<script>

export default {
  name: 'ProductSelector',
  components: {
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    artistId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      products: [],
      selectedProductId: null,
    }
  },
  computed: {
    availableProducts() {
      return [{ id: null, title: 'すべて' }, ...this.products]
    },
  },
  watch: {
    artistId: {
      handler() {
        this.selectedProductId = null
        this.fetchItems()
      },
    },
    selectedProductId: {
      handler(selectedProductId) {
        this.$emit('input', selectedProductId)
      },
      immediate: false,
    },
  },
  mounted() {
  },
  methods: {
    async fetchItems() {
      const { data } = await window.axios.get('/api/client/reports/all-products', {
        params: {
          artist_id: this.artistId,
        },
      })
      this.products = data
    },
  },
}
</script>
